import { isLocalDevelopment } from '@/local-settings';

export const baseURL = isLocalDevelopment ? 'http://localhost:8080/api/v1' : process.env.VUE_APP_BASE_URL;
export const tenantId = process.env.VUE_APP_TENANT_ID;
export const clientId = process.env.VUE_APP_CLIENT_ID;